import React from "react";
import { Dropdown, Tooltip } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { flooringUseMutation } from "../hooks";
import FlooringForms from "../forms";
import {
  EntityRemoveButton,
  Localize,
  ModalStandard,
} from "components/service";
import { localizeByKey, localizeByKeyStatic } from "components/service/localize";
import { TFlooringVariation } from "../helpers/flooring-variation-types-helper";
import Icons from "components/icons";
import { usePermissionByObject, useModelFormValidation } from "components/permissions";
import Flooring from "components/flooring";

interface IFlooringVariationActionFieldProps
{
  variation: TFlooringVariation | undefined;
  variables: Record<string, any>;
}

const FlooringVariationActionField: React.FC<IFlooringVariationActionFieldProps> = ({
  variation,
  variables,
}) =>
{
  const {
    _setMutationFlooringVariationDelete,
    loadingMutationFlooringVariationDelete,
  } = flooringUseMutation.variationDelete(variation?.id, variables);

  const { hasPermission: hasUpdatePermission } = usePermissionByObject(Flooring.Const.permissions.UPDATE);
  const { hasPermission: hasDeletePermission } = usePermissionByObject(Flooring.Const.permissions.DELETE);
  const { validateDeletePermission } = useModelFormValidation(Flooring.Const);

  const items = [
    {
      key: "1",
      label: (
        <Tooltip
          title={!hasUpdatePermission ? `${localizeByKeyStatic("PERMISSION.Error_AccessDenied")}: ${localizeByKeyStatic(Flooring.Const.permissions.UPDATE.slug)}` : undefined}
        >
          <ModalStandard
            disabled={!hasUpdatePermission}
            width={500}
            extraClass={"modal-form"}
            modalButton={
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: 100,
                  opacity: hasUpdatePermission ? 1 : 0.5,
                  pointerEvents: hasUpdatePermission ? "auto" : "none",
                }}
                onClick={(e) =>
                {
                  if (!hasUpdatePermission) {
                    e.preventDefault();
                    e.stopPropagation();
                  }
                }}
              >
                <Icons.Edit /> <Localize>MENUS_DROP.Label_Edit</Localize>
              </span>
            }
            modalTitle={
              <strong className="modal-title">
                <span className="text">
                  <Localize>FORMS.Title_EditPriceVariation</Localize>
                </span>
              </strong>
            }
          >
            <FlooringForms.VariationEdit
              action={() => { }}
              flooringID={variation?.flooring_id ?? ""}
              variation={variation}
              variables={variables}
            />
          </ModalStandard>
        </Tooltip>
      ),
      disabled: !hasUpdatePermission,
    },
    {
      key: "2",
      label: (
        <Tooltip
          title={!hasDeletePermission ? `${localizeByKeyStatic("PERMISSION.Error_AccessDenied")}: ${localizeByKeyStatic(Flooring.Const.permissions.DELETE.slug)}` : undefined}
        >
          <EntityRemoveButton
            modalButton={
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: 100,
                  opacity: hasDeletePermission ? 1 : 0.5,
                }}
              >
                <Icons.Delete /> <Localize>MENUS_DROP.Label_Delete</Localize>
              </span>
            }
            nameEntity={localizeByKey("ENTITY.Modal_Title_FlooringVariation")}
            dataNameEntity={variation?.title}
            loading={loadingMutationFlooringVariationDelete}
            deleteMutation={(options) =>
            {
              if (!validateDeletePermission()) {
                return Promise.reject(new Error("Access denied"));
              }

              return _setMutationFlooringVariationDelete(options);
            }}
            variables={{
              id: variation?.id,
            }}
          />
        </Tooltip>
      ),
      disabled: !hasDeletePermission,
    },
  ];

  return (
    <Dropdown
      placement="bottomRight"
      menu={{ items }}
      overlayClassName="drop-more-menu"
      arrow
    >
      <EllipsisOutlined className="btn-more" />
    </Dropdown>
  );
};

export default FlooringVariationActionField;
